import React from 'react';

import { useImmer } from 'use-immer';

import { BaseCompanyZoneZipSelect, createZoneZipSelectState, ZoneZipSelectState } from './BaseCompanyZipZoneSelect';
import { ZipZoneSelectComponentProps } from './zipZoneSelectContext';

export const DefaultCompanyZipZoneSelect = (props: ZipZoneSelectComponentProps): React.ReactElement => {
  const [zoneZipSelectState, setZoneZipSelectState] = useImmer<ZoneZipSelectState>(createZoneZipSelectState());
  return (
    <BaseCompanyZoneZipSelect
      zoneZipSelectState={zoneZipSelectState}
      setZoneZipSelectState={setZoneZipSelectState}
      {...props}
    />
  );
};
